module.exports = __webpack_public_path__ + "media/images/icons/icn_018-e27aa45ce4a9eb72caaf8b3d25a0d77b.svg";